{
  "CapabilitiesAffected": "Recursos afetados:",
  "ShowRelated": "Mostrar {relatedCount} relacionados"
}
